<script setup lang="ts">
import {TextInput} from "@hantera/design-system";
import {ref, watch} from "vue";

const props = defineProps<{
  modelValue: string
}>()
const emit = defineEmits< {
  (e: 'update:modelValue', value: string): void
}>()

const internalValue = ref(props.modelValue.length >= 2 ? props.modelValue.substring(1, props.modelValue.length - 1) : '');

watch(internalValue, (newValue) => {
  emit('update:modelValue', "'" + internalValue.value + "'");
})

</script>

<template>
  <div>
    <TextInput
      v-model="internalValue"
      class="input"
    />
  </div>
</template>

<style scoped>

</style>